import { render, staticRenderFns } from "./AgentView.vue?vue&type=template&id=12a23ef0&scoped=true&"
import script from "./AgentView.vue?vue&type=script&lang=js&"
export * from "./AgentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a23ef0",
  null
  
)

export default component.exports